import React from 'react';
import {useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  makeStyles
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import MyContext from 'src/MyContext'

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  }
}));



const Toolbar = ({ className, ...rest }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  function prepVehiclePlateDict(users) {
    var pdict = {}
    users.map((item, idx) => {
      pdict[item.plate] = item 
    })
    return pdict

  }

  return (
    <MyContext.Consumer>{context => (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Box
        display="flex"
        justifyContent="flex-end"
      >
       
        <Button
          color="primary"
          variant="contained"
          onClick={ () => {
            navigate('/app/newvehicle', {state: {'plateDict': prepVehiclePlateDict(context.vehicles)}});
          }}
        >
          New Vehicle
        </Button>
      </Box>
    
    </div>
    )}</MyContext.Consumer>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
